<template>
    <HelpListPage
        id="HELP_PAGE_COMMON"
        :heading="$t('helpPage.commonPage.heading')"
        :title="$t('helpPage.commonPage.title')"
        :description="$t('helpPage.commonPage.description')"
    />
</template>

<script>
import HelpListPage from '../../components/help/helpListPage';
import { setPageTitle, setMeta, getPageTitle, getPageMetaDescription } from '@/utils/meta'

export default {
    components: {
        HelpListPage
    },
    created: function() {
        setPageTitle(getPageTitle(this.$route));
        setMeta("description", getPageMetaDescription(this.$route));
    }
}
</script>
